import { Col, DatePicker, Form, Input, Row, Select, Spin } from "antd";
import moment from "moment/moment";
import {
  GutteredRow,
  ResponsiveCol,
} from "../../common/components/AreasPositions/Grid";
import { useSeniorityLevels, useSettingValue } from "../../utils/Hooks";
import { maxValueRule } from "../../utils/input";
import { MoneyField } from "../../utils/MoneyField";
import { validateSalaryRange } from "../../utils/validations";

export const PositionAddForm = ({ form }) => {
  const { TextArea } = Input;
  const { seniorityLevels, isLoading } = useSeniorityLevels();

  const isSalaryRangeEnabled = useSettingValue(
    "T011_POSITION_SALARY_RANGE_ENABLE",
  );

  return (
    <Form layout={"vertical"} form={form}>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Nome do Cargo:"
            name="name"
            rules={[
              { required: true, message: "Por favor insira o nome do cargo." },
              maxValueRule(200),
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <GutteredRow>
        <ResponsiveCol>
          <Form.Item label="Nível de senioridade:" name="seniority_level">
            <Select
              allowClear
              placeholder="Selecione"
              notFoundContent={
                isLoading ? <Spin size="small" /> : "Nenhum item encontrado"
              }
              options={seniorityLevels?.results.map((option) => ({
                value: option.key,
                label: option.level,
              }))}
            />
          </Form.Item>
        </ResponsiveCol>
        <ResponsiveCol>
          <Form.Item
            label="Categoria:"
            name="category"
            rules={[maxValueRule(200)]}
          >
            <Input />
          </Form.Item>
        </ResponsiveCol>
      </GutteredRow>
      <GutteredRow>
        <ResponsiveCol>
          <Form.Item
            label="Código:"
            name="code"
            rules={[
              {
                required: true,
                message: "Por favor insira o código do cargo.",
              },
              maxValueRule(100),
            ]}
          >
            <Input />
          </Form.Item>
        </ResponsiveCol>
        <ResponsiveCol>
          <Form.Item
            label="Data de criação"
            name="start_date"
            initialValue={moment(new Date())}
            rules={[
              {
                required: true,
                message: "Por favor insira a data de criação.",
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </ResponsiveCol>
      </GutteredRow>
      {isSalaryRangeEnabled && (
        <Form.Item label="Faixa de remuneração:" name="salary_range">
          <GutteredRow>
            <ResponsiveCol>
              <Form.Item name="min_salary" noStyle>
                <MoneyField
                  prefix="R$"
                  style={{ width: "100%" }}
                  step={100}
                  min={0}
                  placeholder="Mínimo"
                  precision={4}
                  onChange={() => validateSalaryRange(form)}
                />
              </Form.Item>
            </ResponsiveCol>
            <ResponsiveCol>
              <Form.Item name="max_salary" noStyle>
                <MoneyField
                  prefix="R$"
                  style={{ width: "100%" }}
                  min={1}
                  step={100}
                  placeholder="Máximo"
                  precision={4}
                  onChange={() => validateSalaryRange(form)}
                />
              </Form.Item>
            </ResponsiveCol>
          </GutteredRow>
        </Form.Item>
      )}
      <Row>
        <Col span={24}>
          <Form.Item label="Descrição:" name="description">
            <TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
